module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-25.eb6156c0.jpg";